"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  flex-wrap: wrap;\n  margin-left: -8px;\n  margin-right: -8px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var RowGui = _styledComponents.default.div.attrs(function (_ref) {
  var className = _ref.className;
  return {
    className: className || 'row'
  };
})(_templateObject());

var Row = function Row(props) {
  return /*#__PURE__*/_react.default.createElement(RowGui, props);
};

var _default = Row;
exports.default = _default;